module.exports = __webpack_public_path__ + "14ff1c3f9459c81c1a08223e780f1b07.svg";